import { useSignOut } from "@reboot-dev/reboot-react";
import { sdk } from "../components/Auth/ory-sdk";

// Signs the user out of both the Reboot session and the Ory identity
// provider, then returns the browser to the console origin. Reboot's
// `useSignOut` clears only the Reboot session; Ory's own login session
// outlives it, so the next sign-in reauthenticates that same identity
// with no way to choose a different account. Ory's logout URL clears
// its session cookie and honors `return_to` when it names an allowed
// return URL (the console origin is one).
export function useSignOutFully(): () => Promise<void> {
  const signOut = useSignOut();
  return async () => {
    // Read Ory's logout URL while its session still exists, then clear
    // the Reboot session and hand the browser straight to that URL —
    // navigating before the app can re-render and start a fresh login
    // flow.
    let logoutUrl: string | undefined;
    try {
      ({ logout_url: logoutUrl } = await sdk.createBrowserLogoutFlow({
        returnTo: window.location.origin,
      }));
    } catch {
      // Ory is out of reach — no tunnel under `npm run dev:vite`, or a
      // session it no longer recognizes. Signing out of Reboot is the
      // part that must still happen.
    }
    await signOut();
    window.location.href = logoutUrl ?? window.location.origin;
  };
}
